import React, { useEffect } from 'react';
import { usePageTitle } from '../contexts/PageContext';

interface PageRouteProps {
  title: string;
  children: React.ReactNode;
}

const PageRoute: React.FC<PageRouteProps> = ({ title, children }) => {
  const { setTitle } = usePageTitle();

  useEffect(() => {
    setTitle(title);
  }, [title, setTitle]);

  return <>{children}</>;
};

export default PageRoute;